import {
  DocumentClassAttributes,
  MaterialAttributes,
  OrderDetailAttributes,
  SubRouteAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportOptions } from "app/layout/export-overlay";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "app/modules/components/filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { MaterialService } from "app/modules/components/material/material/material.service";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { MasterUserInterface } from "app/modules/components/sales/order-generate/interfaces/master-user.interface";
import { OrdersListService } from "app/modules/components/sales/order-list-components/order-list.service";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import {
  ColDef,
  GridConfig,
  PageChangedEvent,
  SmartGridComponent,
  SortChangedEvent,
} from "app/shared/components/smart-grid";
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";
import { DateHelper } from "app/utils/date.helper";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { Workbook } from "exceljs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
  takeUntil,
} from "rxjs";
import { ExportDialogComponent } from "../../../../../layout/export-overlay/dialog/export-dialog.component";
import { QuantityCellRendererComponent } from "../order-customer/cell-renderers/quantity-cell-renderer.component";
import {
  NECESSITY_EXPORT_ID,
  NECESSITY_TITLE,
  ORDER_INVOICE_TITLE,
} from "../order-customer/exports/order-customer.constants";
import { OrderCustomerExport } from "../order-customer/exports/order-customer.export";
import { OrderCustomerService } from "../order-customer/order-customer.service";
import { MaterialModalComponent } from "./material-bp-modal/material-bp-modal.component";
import { TotalNecessityMaterialCellRendererComponent } from "./material-cell-renderer.component";
import { StockCellRendererComponent } from "./stock-confirmed-cell-renderer.component";
import { TotalNecessityActionsCellRendererComponent } from "./total-necessity-actions-cell-renderer.component";

declare var ChartsEmbedSDK: any;
@Component({
  selector: "app-total-necessity",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    MatTooltipModule,
    FilterComponent,
    DecimalFormatPipe,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FilterSectionComponent,
    HoverMenuDirective,
    MatMenuModule,
    UnitMeasureDisplayComponent,
    CompanyCurrencyPipe,
    SmartGridComponent,
  ],
  providers: [OrderCustomerExport],
  templateUrl: "./total-necessity.component.html",
  styleUrl: "./total-necessity.component.scss",
})
export class TotalNecessityComponent implements OnDestroy {
  getCode = getCode;
  type = "DT002"; //Pedido

  // SmartGrid Data Structures
  data: any[] = [];
  totalItems: number = 0;
  loading: boolean = false;

  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderDetailAttributes = <any>"code";
  sortDirection: "ASC" | "DESC" = "ASC";

  filter = {
    company: null,
    documentClass: null,
    dateini: new Date(),
    dateend: new Date(),
    warehouseId: null,
    routes: [],
    item: null,
  };

  prefilter: any = {
    company: null,
    dateini: new Date(),
    dateend: new Date(),
    warehouseId: null,
    routes: [],
    item: null,
  };
  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  warehouseList: WarehouseAttributes[] = [];
  warehouseFilterList: WarehouseAttributes[] = [];
  searchWarehouse = "";

  subRouteList: SubRouteAttributes[] = [];
  listFilterSubRouteList: SubRouteAttributes[] = [];
  searchSubRoute = "";

  UMPActive: boolean;

  // SmartGrid Configuration
  columnDefs: ColDef<any>[] = [];
  gridConfig: GridConfig<any> = {
    rowIdField: "_id" as any,
    dataMode: "api",
    sorting: {
      enabled: true,
      mode: "api",
      multiColumn: false,
      defaultSort: [{ field: "code", direction: "asc" }],
    },
    pagination: {
      enabled: true,
      mode: "api",
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
      showFirstLastButtons: true,
    },
    search: {
      enabled: true,
      mode: "api",
      showSearchInput: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
    },
    selection: {
      enabled: false,
    },
    styling: {
      maxHeight: "85vh",
      minHeight: "80vh",
      fontSize: "12px",
      cellPaddingX: "3px",
      cellPaddingY: "0px",
      density: "comfortable",
    },
  };

  materialList: MaterialAttributes[] = [];
  searchMaterial = "";
  private searchSubject = new Subject<string>();

  // selectedDocumentClass: string = '0';
  selectedDocumentClass: string[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  documentClassMultiFilterCtrl: FormControl = new FormControl();
  isIndeterminateDocumentClass: boolean = false;
  isCheckedDocumentClass: boolean = false;
  private _onDestroyDocumentClass = new Subject<void>();

  selectedSeller: string = "0";
  selectedWithTravel: string[] = [];

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];
  private chart: any;

  selectedChart = "top-clients";
  sdk = new ChartsEmbedSDK({
    baseUrl: "https://charts.mongodb.com/charts-cortijo-prod-vehoxep",
  });
  chartIds = {
    "products-sold": "abfe16f5-c98a-4122-95b9-3d81d96d5048",
    "top-clients": "e2698981-779b-4eb5-9b3c-6db4a69b47b6",
  };

  // isChart: boolean = environment.projectName == "CORTIJO" ? false : true;
  isChart: boolean = true;

  //BUSCADOR
  searchSubscription: Subscription;
  form: FormGroup;

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private orderCustomer: OrderCustomerService,
    private readonly warehouseService: WarehouseService,
    private readonly subRouteService: SubRouteService,
    private readonly companyService: CompanyService,
    private snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private orderCustomerExport: OrderCustomerExport,
    private ordersListService: OrdersListService,
    private readonly cdr: ChangeDetectorRef,
    private readonly materialService: MaterialService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private readonly router: Router,
    private fb: FormBuilder
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [],
      end: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
      startDeliveryDate: [],
      endDeliveryDate: [],
      pickerUpload_start: [today],
      pickerUpload_end: [today],
    });
    this.matIconRegistry.addSvgIcon(
      "excel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/mdi--file-excel.svg"
      )
    );
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.initializeColumnDefs();
    this.onHandleSearch();
    // this.fetchDocumentClass();
    // this.getListSeller();
    // this.getListSoldTo(null);
    // this.getListShipTo(null);
  }

  private initializeColumnDefs(): void {
    this.columnDefs = [
      // 1. Material (Code + Name)
      {
        field: "code" as any,
        headerName: "Material",
        minWidth: 250,
        sortable: true,
        cellRenderer: TotalNecessityMaterialCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const code = item.code ?? "-";
            const name = item.name ?? "-";
            return `${code} - ${name}`;
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const code = rowData.code ?? "-";
            const name = rowData.name ?? "-";
            const displayValue = `${code} - ${name}`;
            if (!displayValue || displayValue === "- - -") return !filterValue;
            return displayValue === filterValue;
          },
        },
      },

      // 2. Cantidad (UMB + UMP)
      {
        field: "baseQuantity",
        headerName: "Cantidad Solicitada",
        cellRenderer: QuantityCellRendererComponent,
        cellRendererParams: {
          getUMPActive: () => this.UMPActive,
        },
        minWidth: 200,
        sortable: false,
      },

      // 2. Cantidad Confirmada(Asistente) (UMB + UMP)
      {
        field: "stockConfirmedERP",
        headerName: "Cantidad Confirmada",
        cellRenderer: StockCellRendererComponent,
        cellRendererParams: {
          getUMPActive: () => this.UMPActive,
        },
        minWidth: 200,
        sortable: false,
      },


      // 3. Actions
      {
        field: "actions",
        headerName: "Acciones",
        minWidth: 150,
        maxWidth: 150,
        sortable: false,
        cellClass: "text-right",
        cellRenderer: TotalNecessityActionsCellRendererComponent,
        cellRendererParams: {
          onOpenMaterial: (data: any) => this.openMaterial(data),
          onGoToOrder: (data: any) => this.goToOrder(data),
        },
        pinned: "right",
      },
    ];
  }

  ngAfterViewInit(): void {
    // if(!this.isChart){
    //   this.renderChart(this.chartIds[this.selectedChart]);
    // }
    this.fetchCompanies();
    // this.fetchAllWarehouses();
    // this.onFilter();

    this.documentClassMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroyDocumentClass))
      .subscribe(() => {
        this.filterDocumentClasses();
        this.setToggleAllCheckboxStateDocumentClass();
      });

    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((filterValue: string) => {
        this.pageIndex = 1;
        this.search = filterValue;
        this.onFilter();
      });

    this.soldToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }
        this.soldToList = [];
        this.soldToFilterSelected = null;
        this.getListSoldTo(value);

        // this.getListReport();
      });

    this.shipToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.shipToList = [];
        this.getListShipTo(value);
        // this.getListReport();
      });

    this.setupMaterialSearchControl();
    // this.getMaterialList();
  }

  filterByMaterial(element): void {
    if (!this.chart) return;

    const filtro: any = {};

    if (element) {
      filtro["materialCodigo"] = element;
    }
    this.chart.setFilter(filtro);
  }

  // ngOnDestroy(): void {
  //   if (!this.isChart) {
  //     if (this.chart) {
  //       this.chart.destroy();
  //     }
  //   }
  // }

  private renderChart(chartId: string, filter: any): void {
    const container = document.getElementById("chart-d");
    if (container) {
      container.innerHTML = "";
    }

    const isNonEmpty = (value) => {
      if (value == null) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (Array.isArray(value)) return value.length > 0;
      return true;
    };

    const matchStage = {
      // _deleted: { $ne: true },
      // "type.code": DocumentTypeEnum.PEDIDO,
      ...(this.selectedSeller?.toString() !== "0" && {
        "user.user_login.username": this.selectedSeller.toString(),
      }),
      ...(this.selectedDocumentClass?.length > 0 && {
        "class.code": { $in: this.selectedDocumentClass },
      }),
      ...(isNonEmpty(this.soldToControl.value) && {
        "soldTo.id": this.soldToControl.value,
      }),
      ...(isNonEmpty(this.shipToControl.value) && {
        "shipTo.id": this.shipToControl.value,
      }),
      ...(this.filter.routes?.length > 0 && {
        "subRoute.id": { $in: this.filter.routes },
      }),
      ...(this.filter.warehouseId && {
        "warehouses.id": {
          $in: this.filter.warehouseId ? [this.filter.warehouseId] : [],
        },
      }),
      ...(this.filter.item?.length > 0 && {
        "detail.material.code": { $in: this.filter.item },
      }),
      createdAt: {
        $gte: { $date: filter.start },
        $lte: { $date: filter.end },
      },
    };

    this.chart = this.sdk.createChart({
      chartId: chartId,
      preFilter: matchStage,
    });
    this.chart
      .render(document.getElementById("chart-d"))
      .then(() => {
        const iframe = document.querySelector(
          "#chart-d iframe"
        ) as HTMLIFrameElement;
        if (iframe) {
          iframe.style.backgroundColor = "#f9fafb"; // bg-gray-50
          iframe.style.borderRadius = "0.375rem"; // rounded-md
          iframe.style.minHeight = "400px";
        }
      })
      .catch((err) =>
        this.snackBar.open(
          err.error.message || "Error al renderizar gráfico:",
          "Cerrar",
          { duration: 5000 }
        )
      );
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: this.type,
    };
    // this.ordersListService.fetchDocumentClasses(dataToFilter).subscribe((res) => {
    //   this.documentClassesList = res.data;
    // })
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.onFilter();
      }
    );
  }

  onFilter() {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });

    this.getListReport();
  }

  private filterDocumentClasses(): void {
    if (!this.documentClassesList) {
      return;
    }
    let search = this.documentClassMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentClasses.next(this.documentClassesList);
      return;
    } else {
      search = search.toLowerCase();
    }
    const filtered = this.documentClassesList.filter((docClass) =>
      docClass.name.toLowerCase().includes(search)
    );
    this.filteredDocumentClasses.next(filtered);
  }

  private setToggleAllCheckboxStateDocumentClass(): void {
    const selectedCount = this.selectedDocumentClass.length;
    const totalCount = this.documentClassesList.length;

    this.isCheckedDocumentClass =
      selectedCount > 0 && selectedCount === totalCount;
    this.isIndeterminateDocumentClass =
      selectedCount > 0 && selectedCount < totalCount;
  }

  onClearFilter() {
    this.filter = {
      company: this.filter.company,
      documentClass: null,
      dateini: new Date(),
      dateend: new Date(),
      warehouseId: null,
      routes: [],
      item: null,
    };
    (this.selectedDocumentClass = null),
      this.range.reset({
        start: new Date(),
        end: new Date(),
      });
    this.form.reset({
      start: new Date(),
      end: new Date(),
    });
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getListReport();
  }

  // SmartGrid Event Handlers
  onPageChanged(event: PageChangedEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getListReport();
  }

  onSortChanged(event: SortChangedEvent<any>): void {
    if (event.sortStates.length > 0) {
      const sortState = event.sortStates[0];
      this.sortActive = sortState.field as keyof OrderDetailAttributes;
      this.sortDirection = sortState.direction === "asc" ? "ASC" : "DESC";
    } else {
      this.sortActive = <any>"code";
      this.sortDirection = "ASC";
    }
    this.getListReport();
  }

  getListReport() {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField(),
      sortDirection: this.sortDirection,
    };

    const adjustedStart = new Date(this.filter.dateini);
    adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

    const adjustedEnd = new Date(this.filter.dateend);
    adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

    let filter: IFilters = {
      type: this.type,
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
      startDeliveryDate: DateHelper.getStartOfDay(
        this.form.get("startDeliveryDate")?.value
      ),
      endDeliveryDate:
        DateHelper.getEndOfDay(this.form.get("endDeliveryDate")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startDeliveryDate")?.value) ??
        null,
      pickerUpload_start: DateHelper.getStartOfDay(
        this.form.get("pickerUpload_start")?.value
      ),
      pickerUpload_end:
        DateHelper.getEndOfDay(this.form.get("pickerUpload_end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("pickerUpload_start")?.value) ??
        null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value, //
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value, //
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      materialId: this.form.get("materialId").value,
      materialGroupId: this.form.get("materialGroupId").value,
      ordersToFilter: null,
    };

    this.prefilter = filter;
    if (!this.isChart) {
      this.renderChart(this.chartIds[this.selectedChart], filter);
    }

    this.orderCustomer.getOrdersGroupedByMaterial(options, filter).subscribe({
      next: (res: IPaginationResult<OrderDetailAttributes>) => {
        this.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.loading = false;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener reporte",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getSortField(): keyof OrderDetailAttributes {
    const sortFieldMapping: Record<string, keyof OrderDetailAttributes> = {
      subRoute: <any>"subRoute.name",
      user: <any>"user",
      serials: <any>"serials",
      date: <any>"date",
      shipToExternalKeyCode: <any>"shipToExternalKeyCode",
      code: <any>"code",
      material: <any>"code",
      soldQuantity: "soldQuantity",
      baseUnitOfMeasure: "baseUnitOfMeasure",
      unitPrice: "unitPrice",
      subTotal: "subTotal",
      total: "total",
    };
    return (
      sortFieldMapping[this.sortActive] ||
      ("name" as keyof OrderDetailAttributes)
    );
  }

  //filter
  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
      }
    });
  }

  private fetchAllWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.warehouseFilterList = this.warehouseList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching warehouses",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsWarehouse(event) {
    if (!this.warehouseList) {
      return;
    }
    let search = event;
    if (!search) {
      this.warehouseFilterList = this.warehouseList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.warehouseFilterList = this.warehouseList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changeWarehouse(event): void {
    this.subRouteList = [];
    this.listFilterSubRouteList = [];
    this.getAllRutas();
  }

  private getAllRutas(): void {
    this.subRouteService
      .findToWarehouse(this.filter.warehouseId ? [this.filter.warehouseId] : [])
      .subscribe({
        next: (res) => {
          this.subRouteList = res.data;
          this.listFilterSubRouteList = this.subRouteList.slice();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching route",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  changueOptionsSubRoute(event) {
    if (!this.subRouteList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSubRouteList = this.subRouteList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSubRouteList = this.subRouteList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  onExportButtonPressed() {
    if (!this.orderCustomerExport.canStartTask()) return;
    const dialogRef = this.matDialog.open(ExportDialogComponent, {
      data: { title: ORDER_INVOICE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderCustomerExport.exportNecessity(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          NECESSITY_EXPORT_ID,
          NECESSITY_TITLE
        );
      }
    });
  }

  onDocumentClassSelectionChange(selectedValues: string[]): void {
    this.selectedDocumentClass = selectedValues;
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching sellers",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  fetchSoldToName = (soldtoId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldtoId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  changueOptionsMaterial(event) {
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchMaterial = searchTerm;
          this.getMaterialList();
        }
      });
  }

  private getMaterialList(): void {
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.materialService
      .findAllWithCount(
        materialOptions,
        this.filter.company ? this.filter.company : []
      )
      .subscribe({
        next: (res: IPaginationResult<MaterialAttributes>) => {
          this.materialList = res?.data?.[0]?.data ?? [];
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al traer registros",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  openMaterial(element): void {
    this.dialog.open(MaterialModalComponent, {
      width: "80vw",
      height: "80vh",
      maxWidth: "1200px",
      maxHeight: "900px",
      data: { element, prefilter: this.prefilter },
      disableClose: true,
    });
  }

  goToOrder(element: any) {
    if (element?.code) {
      if (element.code.length > 0) {
        const pickerStart = this.form.get("pickerUpload_start")?.value;
        const pickerEnd = this.form.get("pickerUpload_end")?.value;
        const queryParams = {
          code: [element.code],
          pickerUpload_start: pickerStart,
          pickerUpload_end: pickerEnd,
        };
        const urlTree = this.router.createUrlTree(
          ["reports", "historic", "order-customer"],
          { queryParams }
        );
        const absoluteUrl =
          window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, "_blank");
      }
    }
  }

  changeChart(): void {
    const chartId = this.chartIds[this.selectedChart];
    this.renderChart(chartId, this.prefilter);
  }

  public async exportChart() {
    try {
      // 1. Obtener datos del gráfico
      const chartData = await this.chart.getData();

      //  Verificar si hay datos para exportar
      if (!chartData.documents || chartData.documents.length === 0) {
        this.snackBar.open("No hay datos para exportar", "Cerrar", {
          duration: 3000,
        });
        return;
      }

      let fileName =
        this.selectedChart === "top-clients" ? "top_clientes" : "top_productos";
      let sheetName =
        this.selectedChart === "top-clients"
          ? "Mejores Clientes"
          : "Productos Más Vendidos";

      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(sheetName);

      const isProducts = this.selectedChart === "products-sold";
      const dataKey = isProducts ? "label" : "x";
      const valueKey = isProducts ? "value" : "y";

      worksheet.addRow([chartData.fields[dataKey], chartData.fields[valueKey]]);

      chartData.documents.forEach((item) => {
        worksheet.addRow([item[dataKey], item[valueKey]]);
      });

      // 6. Formatear columnas
      worksheet.columns = [
        {
          header: chartData.fields[dataKey],
          key: "item",
          width: isProducts ? 50 : 40,
        },
        {
          header: chartData.fields[valueKey],
          key: "total",
          width: 20,
          style: {
            numFmt: "#,##0.00",
            alignment: { horizontal: "right" },
          },
        },
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      this.snackBar.open(
        err.error.message || "Error al exportar a Excel:",
        "Cerrar",
        { duration: 5000 }
      );
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
